
export default function AboutCTA() {
  return (
    <section className="py-20 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Ready to Join Our Community?
        </h2>
        <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
          Become part of a global network of innovative businesses, entrepreneurs, and industry leaders who are shaping the future of commerce.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            Become a Member
          </button>
          <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">
            Partner with Us
          </button>
        </div>
        
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <div className="text-3xl font-bold text-white mb-2">2,500+</div>
            <div className="text-blue-100">Active Members</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-white mb-2">45+</div>
            <div className="text-blue-100">Countries Served</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-white mb-2">850+</div>
            <div className="text-blue-100">Partner Companies</div>
          </div>
        </div>
      </div>
    </section>
  );
}
